import Vue from "vue"
import VueRouter from "vue-router"

import Home from 'views/home/home'
// import MobileHome from 'views/mobile/home/MobileHome'
// import Product_add from 'components/product/product_add'
// import Booking from 'components/booking/booking-list'
// import Detail from 'components/booking/booking-detail'
// import Product from 'components/product/product-trip'
// import Companyconfig from 'components/booking/company-config'
// import Profile from 'components/booking/profile'
// import Center from 'components/common/center'
// 懒加载导入组件

// 移动端
const MproductList = () => import('views/mobile/product/MproductList')  // 产品列表
const MproductIntroduce = () => import('views/mobile/product/MproductIntroduce')  // 产品列表
const MmakeResveration = () => import('views/mobile/product/MmakeResveration')  // 产品预定

const MbookingList = () => import('views/mobile/booking/MbookingList')  // 订单列表
const MbookingVoucher = () => import('views/mobile/booking/MbookingVoucher')  // 订单列表

const Mlogin = () => import('views/mobile/home/login')  // 登陆
const SurferHome = () => import('views/mobile/home/SurferHome')
const RequirementForm = () => import('views/mobile/TravelPlan/RequirementForm')

const termsAndPrivacy = () => import('views/mobile/other/termsAndPrivacy')



// 首页
const TraverData = () => import("views/index/traverData")
const BookingData = () => import("views/index/BookingData")
const UserData = () => import("views/index/UserData")
// 订单
const BookingList = () => import("views/booking/BookingList")
const BookingDetail = () => import('views/booking/BookingDetail')
const BookinngBill = () => import('views/booking/BookingBill')
// 产品
const ProductList = () => import('views/product/ProductList')
const ProductAdd = () => import('views/product/ProductAdd')
const ProductIntro = () => import('views/product/ProductIntro')
// 设置
const Profile = () => import('components/booking/Profile')
const ConfigPage = () => import('views/config/ConfigPage')
const PoiHubAdd = () => import('views/config/PoiHubAdd')
const SzsxConfig = () => import('views/config/SzsxConfig')
const CompanyConfig = () => import('views/config/CompanyConfig')
const OperatorList = () => import('views/config/OperatorList')
const OperatorAddRenew = () => import('views/config/OperatorAddAndRenew')
const TraverGuideConfig = () => import('views/config/TraverGuideConfig')



// 登陆等
const Login = () => import('views/login/login')
const Register = () => import('views/register/register')
const Demand = () => import('components/common/demand/demand')

// 课程
const Course = () => import('views/certificate/Course')
const CreatNewCourse = () => import('views/certificate/CreatNewCourse')
const ReNewCourseInfor = () => import('views/certificate/ReNewCourseInfor')
const CreatNewSection = () => import('views/certificate/CreatNewSection')
const ReNewSectionContent = () => import('views/certificate/ReNewSectionContent')
const CreatNewCoach = () => import('views/certificate/CreatNewCoach')

const CourseContentManage = () => import('views/certificate/CourseContentManage')
const CourseClubManage = () => import('views/certificate/CourseClubManage')
const ContentAndModify = () => import('views/certificate/ContentAndModify')

// 证书
const TraineeList = () => import('views/certificate/TraineeList')
const Certificate = () => import('views/certificate/Certificate')

// 行程规划
const ContentList = () => import('views/guide/ContentList')
const CreatContent = () => import('views/guide/CreatContent')
const ModifyContent = () => import('views/guide/ModifyContent')

const ResidenceHubList = () => import('views/guide/ResidenceHubList')
const ResidenceIntroduce = () => import('views/guide/ResidenceIntroduce')

const BeforeTripList = () => import('views/guide/BeforeTripList')
const BeforeTripListAdd = () => import('views/guide/BeforeTripListAdd')
const BeforeTripListModify = () => import('views/guide/BeforeTripListModify')

const CheckList = () => import('views/guide/CheckList')
const CheckListAdd = () => import('views/guide/CheckListAdd')

const TraverPointList = () => import('views/guide/TraverPointList')
const CheckTraverPoint = () => import('views/guide/CheckTraverPoint')
const GuideGroupDetail = () => import('views/guide/GuideGroupDetail')

const DayTripList = () => import('views/guide/DayTripList')
const CreatDayTrip = () => import('views/guide/CreatDayTrip')
const UpdateDayTrip = () => import('views/guide/UpdateDayTrip')

const TravelPlanList = () => import('views/guide/TravelPlanList')
const CreatTravelPlan = () => import('views/guide/CreatTravelPlan')
const ModifyTravelPlan = () => import('views/guide/ModifyTravelPlan')
const RequirementList = () => import('views/guide/RequirementList')
const ReservationForm = () => import('views/guide/ReservationForm')



// 测试组件
const EditorList = () => import('../components/common/editor/TestCopyContentToEditor')

Vue.use(VueRouter)

// https://blog.csdn.net/delise9787/article/details/107324777?utm_medium=distribute.pc_relevant_t0.none-task-blog-BlogCommendFromBaidu-1.control&depth_1-utm_source=distribute.pc_relevant_t0.none-task-blog-BlogCommendFromBaidu-1.control
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}



const routes = [
  {
    path: '',
    redirect: '/booking_data'
  },

  // home主页
  {
    name: 'home',
    path: '/home',
    component: Home,
    children: [
      // 首页
      { name: "traver_data", path: '/traver_data', component: TraverData },
      { name: "booking_data", path: '/booking_data', component: BookingData },
      { name: "user_data", path: '/user_data', component: UserData },
      // 预定管理的路由
      { name: 'booking_list', path: '/booking_list', component: BookingList, children: [{ name: 'detail', path: '/detail', component: BookingDetail }] },
      { name: 'detail_page', path: '/booking_detail', component: BookingDetail }, // 单独的订单详情页，暂时没有用
      { name: 'product', path: '/product_list', component: ProductList },
      { name: 'product_add', path: '/product_add', component: ProductAdd },

      { name: 'check_list', path: '/check_list', component: CheckList },
      { name: 'check_list_add', path: '/check_list_add', component: CheckListAdd },

      { name: 'before_trip_list', path: '/before_trip_list', component: BeforeTripList },
      { name: 'before_trip_list_add', path: '/before_trip_list_add', component: BeforeTripListAdd },
      { name: 'before_trip_list_modify', path: '/before_trip_list_modify', component: BeforeTripListModify },

      { name: 'booking_bill', path: '/booking_bill', component: BookinngBill },
      // 个人中心
      { name: 'proflie', path: '/profile', component: Profile },
      // 服务商管理
      { name: 'operator_list', path: "/operator_list", component: OperatorList },
      { name: "operator_add_renew", path: "/operator_add_renew", component: OperatorAddRenew },
      // 基本配置
      {
        name: 'szsx_configpage',
        path: '/szsx_configpage',
        component: SzsxConfig
      },


      // 行程规划配置
      {
        name: 'traver_guide_config',
        path: "/traver_guide_config",
        component: TraverGuideConfig
      },

      // 添加 poi
      {
        name: 'add_poi',
        path: '/add_poi',
        component: PoiHubAdd
      },
      // 全局配置
      {
        name: 'Company-config',
        path: '/company-config',
        component: CompanyConfig
      },
      {
        name: "ConfigPage", path: '/configPage', component: ConfigPage
      },
      // 证书中心
      { name: 'certificate', path: '/certificate', component: TraineeList, children: [] },
      {
        name: 'course',
        path: '/course',
        component: Course,

      },
      { name: 'show_certificate', path: '/certificate/show_certificate', component: Certificate },
      // 课程 管理
      { name: 'course_content_manage', path: '/course_content_manage', component: CourseContentManage },
      // 课程的俱乐部
      { name: 'course_club_manage', path: '/course_club_manage', component: CourseClubManage },
      { name: "content_and_modify", path: '/content_and_modify', component: ContentAndModify },

      { name: 'creat_new_courese', path: '/creat_courese', component: CreatNewCourse },
      { name: 're_new_course', path: '/re_new_course', component: ReNewCourseInfor },
      { name: 'creat_new_section', path: '/course_creat_section', component: CreatNewSection },
      { name: 're_new_section', path: '/re_new_section', component: ReNewSectionContent },

      { name: 'creat_new_coach', path: '/creat_new_coach', component: CreatNewCoach },

      // 行程规划
      { name: 'traver_point_list', path: '/traver_point_list', component: TraverPointList },
      { name: 'content_list', path: '/content_list', component: ContentList },
      { name: 'residence_hub_list', path: '/residence_hub_list', component: ResidenceHubList },
      { name: 'creat_content', path: '/creat_content', component: CreatContent },
      { name: 'modify_content', path: '/modify_content', component: ModifyContent },
      { name: 'day_trip_list', path: '/day_trip_list', component: DayTripList },
      { name: 'travel_plan_list', path: '/travel_plan_list', component: TravelPlanList },
      // 帮你做攻略
      { name: 'requirement_list', path: '/requirement_list', component: RequirementList },

    ]
  },
  // {
  //     name: 'detail',
  //     path: '/detail',
  //     component: Detail
  // },
  // 行程规划
  { name: 'check_traver_point', path: '/check_traver_point', component: CheckTraverPoint },
  { name: 'residence_introduce', path: '/residence_introduce', component: ResidenceIntroduce },
  { name: 'guide_group_detial', path: '/guide_group_detial', component: GuideGroupDetail },
  { name: 'creat_day_trip', path: '/creat_day_trip', component: CreatDayTrip },
  { name: 'update_day_trip', path: '/update_day_trip', component: UpdateDayTrip },
  { name: 'creat_travel_plan', path: '/creat_travel_plan', component: CreatTravelPlan },
  { name: 'modify_travel_plan', path: '/modify_travel_plan', component: ModifyTravelPlan },
  // 费用计算
  { name: 'reservation_form', path: '/reservation_form', component: ReservationForm },

  // 产品管理
  { path: `/product-intro`, name: 'product-introduce', component: ProductIntro },

  // 需求单
  { path: '/demand', component: Demand, },
  { path: '/login', name: 'login', component: Login, meta: { title: ' 登陆' } },
  { path: '/register', component: Register },
  { path: '/register', redirect: '/register' },
  //  组件页------
  {
    // 编辑器
    name: "editor-list",
    path: "/editor-list",
    component: EditorList
  },

  // 移动端
  { name: "m_login", path: "/m_login", component: Mlogin },
  { name: 'm_product_list', path: '/m_product_list', component: MproductList },
  { name: 'm_product_introduce', path: '/m_product_introduce', component: MproductIntroduce },
  { name: 'm_make_resveration', path: '/m_make_resveration', component: MmakeResveration },
  { name: "booking_list/sys_m", path: "/booking_list/sys_m", component: MbookingList },
  { name: "m_booking_voucher", path: "/m_booking_voucher", component: MbookingVoucher },
  { name: 'requirement_form', path: "/requirement_form", component: RequirementForm },
  { name: "surferhome", path: "/starsurfer/home", component: SurferHome },
  { name: "termsAndPrivacy", path: '/other/termasAndPrivacy', component: termsAndPrivacy }

]
// 创建router 对象
const router = new VueRouter({
  routes,
  // 修改路由显示模式
  mode: 'history'

})

// 导航守卫【路由守卫】：在路由配置生效之前，来到这个方法, 想要继续生效需要调用next（）
router.beforeEach((to, from, next) => {
  // 跳转前来到这个方法 console.log("跳转前打印我")
  // to: 要去的路由配置的相关信息，可通过 conslole.log(to)  查看。
  // from: 当前的路由配置相关信息。
  // next: 执行的函数。（处理下一个环节，类似中间件。）
  // 
  // vuex 中获取登陆登陆状态
  // console.log(router.app.$options.store.state.hasLogin)
  // console.log(to.path);
  if (to.path === "/login" || to.path === "/register" || to.path === "/m_login" || to.path === "/other/termasAndPrivacy") {
    // 如果要去的是登陆页， 则执行 next（）
    next()
  } else {
    // 如果要去的不是登陆页， 判断是否登陆。
    // console.log(router.app.$options.store.state.hasLogin);
    if (router.app.$options.store.state.hasLogin === true) {
      next()
    } else {
      // token
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo == null) {
        // 判断当前设备
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );

        console.log(flag);
        if (flag === null) {
          console.log("pc端");
          router.push({ name: 'login' })
        } else {
          router.push({ name: 'm_login' })
        }
        // 本身就是router对象，直接使用。
        return

      } else if (userInfo.token) {
        next()
      }

    }
  }

});



export default router